import React from 'react';

import TermsAndConditions from '../screens/static/TermsAndConditions';
import PrivacyPolicy from '../screens/static/PrivacyPolicy';
import CallUs from '../screens/static/CallUs';

class Popup extends React.Component {

    closePopup(e) {
        if (e.target.className == 'popup-overlay')
            this.props.hidePopup();
    }
    clickHandler() {
        if (this.props.buttonAction) {
            this.props.buttonAction();
            this.props.hidePopup();
        } else {
            this.props.hidePopup();
        }
    }

    renderContent(content, type, centered, customParams) {
        let out = '';
        switch(type) {
            case 'CallUs':
                out = CallUs(customParams);
                break;
            default:
                out = content;
        }
        if (out) return <div className={'popup-content '+(centered ? 'centered' : '')}>{ out }</div>
    }

    renderPopupBody(mode) {
        let { title, content, buttonText, large, buttonAction,
            customType, isConfirm, customParams, centered, url } = this.props;

        if (!mode) {
            return (
                <div className={large ? 'large popup' : 'popup'}>
                    { title && <h1 className='popup-title'>{ title }</h1>}
                    { this.renderContent(content, customType, centered, customParams) }
                    { isConfirm ?
                        <div className='popup-buttons'>
                              <div className='multi-column-row'>
                                  <div className='column'>
                                      <button
                                          onClick={ this.clickHandler.bind(this) }
                                          className='button button-block popup-button'>
                                          Yes
                                      </button>
                                  </div>
                                  <div className='column'>
                                      <button
                                          onClick={ this.props.hidePopup }
                                          className='button button-block'>No</button>
                                  </div>
                              </div>
                        </div>
                      : 
                      ( url ?
                          <div className='popup-buttons'>
                            <a href={url} className='button button-block popup-button'>
                              { buttonText }
                            </a>
                          </div>
                        :  
                          <div className='popup-buttons'>
                            <button
                                onClick={ this.clickHandler.bind(this) }
                                className='button button-block popup-button'>
                                { buttonText }
                            </button>
                          </div>
                      )}
                </div>
            );
        }

    }

	render() {
        return (
            <div className='popup-overlay'
                onClick={ this.closePopup.bind(this) }
                style={{display: this.props.visible ? 'block' : 'none' }}>

                { this.renderPopupBody(this.props.mode) }

            </div>
        )
    }
}

Popup.defaultProps = {
    buttonText: 'Ok',
    isConfirm: false,
}

export default Popup;



// WEBPACK FOOTER //
// ./source/components/popup.js